import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from '../src/store';

import App from '../src/components/App';

import './index.scss';
import "@fortawesome/fontawesome-free/css/all.min.css";


ReactDOM.render(
  <BrowserRouter>
    <StoreProvider>
      <App></App>
    </StoreProvider>
  </BrowserRouter>,
  document.querySelector('#root')
);
